export const headCells = [
  {
    id: "image",
    numeric: false,
    disablePadding: false,
    label: "Image",
  },
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  // {
  //   id: "Description",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Description",
  // },

  {
    id: "date",
    numeric: false,
    disablePadding: false,
    label: "Date",
  },

  {
    id: "action",
    disablePadding: false,
    label: "Action",
  },
];
